import service1 from "../Image/service1.jpg"
import service2 from "../Image/service2.jpg"
import service3 from "../Image/service3.jpg"
import service4 from "../Image/service4.jpg"
import service5 from "../Image/service5.jpg"
import service6 from "../Image/service6.jpg"
import service7 from "../Image/service7.jpg"
import service8 from "../Image/service8.jpg"
import service9 from "../Image/service9.jpg"
import service10 from "../Image/service10.jpg"
import service11 from "../Image/service11.jpg"
import service12 from "../Image/service12.jpg"
import service13 from "../Image/service13.jpg"
import service14 from "../Image/service14.jpg"
import service15 from "../Image/service15.jpg"
import yearSur from "../Image/yearSur.png"
import pandya from "../Image/pandya.png"
import summit from "../Image/summit.png"
import nidhi from "../Image/nidhi.png"
import fashion from "../Image/fashion.png"
import rio from "../Image/rio.png"
import topten from "../Image/topten.png"
import bollywood from "../Image/bollywood.png"
import sultan from "../Image/sultan.png"
import muhmmad from "../Image/muhmmad.png"
import AMMUNITION from "../Image/Ammunation.png"
import rcb from "../Image/rcb.png"
import vivoipl from "../Image/vivoipl.png"
import sachin from "../Image/sachin.png"
import sirjadeja from "../Image/sirjadeja.png"
import indbang from "../Image/indbang.png"
import powerofBirth from "../Image/powerofbirth.png"
import UMESHYADHAV from "../Image/UMESHYADHAV.jpg"
import eight from "../Image/eightnumber.png"
import mumbai from "../Image/mumbai.jpg"
import magic10 from "../Image/number10.png"
import numerlogy1 from "../Image/numerlogy1.jpg"
import numerlogy2 from "../Image/numerlogy2.png"
import numerlogy3 from "../Image/number23.png"
// import bollywood from "../Image/bollywood.jpg"

export const predictionData = [
    {
        "id": 1,
        "title": "2023 Predictions Come True!",
        "image": yearSur ,
        "paragraph": "2023 Predictions: A Look Back at What Came True! In the ever-evolving tapestry of life, …",
        "quote": "\"As we bid farewell to 2023, we are left in awe of the remarkable alignment between predictions and reality.\"",
        "buttonText": "Read More"
    },
    {
        "id": 2,
        "title": "Number six and its significance on Indian cricket",
        "image":  pandya,
        "paragraph": "Cricket is a game of numbers. Runs, wickets, averages, strike rate, economy, records...",
        "quote": "Number 6 is very lucky for India",
        "buttonText": "Read More"
    },
    {
        "id": 3,
        "title": "9/11 World Trade Center Attack",
        "image": summit,
        "paragraph": "Can A Number Be Responsible For Such A Massive Attack.",
        "quote": "Is There Any Number Connection Of Osama’s Death.",
        "buttonText": "Read More"
    },

    {
        "id": 5,
        "title": "Your Date of Birth is a road map of your destiny.",
        "image": nidhi ,
        "paragraph": "Whats a better way to feel proud as a numerologist, When Your prediction come true.",
        "quote": "#ProudMoment #ProudPrediction #Proud_of_you_Nidhi",
        "buttonText": "Read More"
    },
    {
        "id": 6,
        "title": "IS YOUR CAREER SUITABLE ACCORDING TO YOUR DATE OF BIRTH",
        "image":  fashion,
        "paragraph": "I assessed her birth chart and told her to choose Fashion designing and predicted that her 24 age would be her turning point.",
        "quote": "#inifdrocks #londonfashionweek #fashionscout #historymaking#proudofyouNidhi",
        "buttonText": "Read More"
    },
    {
        "id": 7,
        "title": "Rio Olympic 2016",
        "image":  rio ,
        "paragraph": "Most of the games in the olympic are used to be the individual sports.",
        "quote": "Success = when preparation meets the opportunity",
        "buttonText": "Read More"
    },
    {
        "id": 8,
        "title": "What numbers can do ???",
        "image": topten,
        "paragraph": "I suggested my well-wisher Mr. Bablu Maheshwari to let his daughter choose the fashion designing field.",
        "quote": "Numbers can definitely assist your Hard Work.",
        "buttonText": "Read More"
    },
    {
        "id": 9,
        "title": "OMG Sultan’s success lies in the numbers.",
        "image": sultan ,
        "paragraph": "The Salman Khan, Anushka Sharma film has earned a gross of Rs 520 crore at the box office.",
        "quote": "Numbers can definitely assist your Hard Work.",
        "buttonText": "Read More"
    },
    {
        "id": 10,
        "title": "THE GREATEST ‘MUHAMMAD ALI’ HAS PASSED AWAY AT THE AGE OF 74",
        "image": muhmmad ,
        "paragraph": "It was predicted by me on 14th January 2016 that the world may loose few famous sports person this year.",
        "quote": "Numbers can definitely assist your Hard Work.",
        "buttonText": "Read More"
    },
    {
        "id": 11,
        "title":  "It was already predicted by me, on date 7th feb 2016" ,
        "image": AMMUNITION ,
        "paragraph": "It was already predicted by me, on date 7th feb 2016, that more fire incidents would happen in india this year.",
        "quote": "Previously a chemical factory blast in Mumbai and now in Vidarbha.",
        "buttonText": "Read More"
    },
    {
        "id": 12,
        "title": "RCB vs SRH Big final",
        "image": rcb ,
        "paragraph": "Today’s date is 29th May 2016, which comes under the effect of 2 and 7.",
        "quote": "Today’s date is more favourable to RCB",
        "buttonText": "Read More"
    },
    {
        "id": 13,
        "title": "Vivo IPL 2016 Qualifier 2",
        "image":  vivoipl,
        "paragraph": "Today’s prediction.As today’s date is also 27=2+7=(9)Its lucky for both the captains.",
        "quote": "Today’s prediction.As today’s date is also 27=2+7=(9)",
        "buttonText": "Read More"
    },
    {
        "id": 14,
        "title": "The GOD of CRICKET. SACHIN RAMESH TENDULKAR",
        "image":  sachin,
        "paragraph": "The god of cricket Sachin Tendulkar turns 43 today (24th April 2016).",
        "quote": "He is truly a blessed person.",
        "buttonText": "Read More"
    },
    {
        "id": 15,
        "title": "Sir Ravindra Jadeja - Bangladesh Tour",
        "image": sirjadeja,
        "paragraph": "Sir Ravindra Jadeja is dropped from the Indian Cricket Team for Bangladesh Tour",
        "quote": "Numbers can definitely assist your Hard Work.",
        "buttonText": "Read More"
    },
    {
        "id": 16,
        "title": "India will be facing Bangladesh in asia cup final",
        "image": indbang , 
        "paragraph": "No doubt inform india is having more chances to win the asia cup but today it could be a day of Shikhar, kohli , Raina in batting.",
        "quote": "Numbers can definitely assist your Hard Work.",
        "buttonText": "Read More"
    },
    {
        "id": 4,
        "title": "Can a specific number help you achieve success?",
        "image": "https://static.toiimg.com/thumb/msid-66246674,width-400,resizemode-4/66246674.jpg",
        "paragraph": "Despite the loss of 2nd ODI, we must praise Hardik Pandya and Umesh Yadav for their efforts…",
        "quote": "Now, Umesh has become an integral part of the team India.",
        "buttonText": "Read More"
    },
];

export const blogsData = [
    {
        title: "Mumbai terror attacks and numerology behind it",
        date: "January 21, 2021",
        description:
            "⁠⁠⁠On the eve of sixth anniversary of MUMBAI TERROR ATTACK wanna share something about number 26 and number 8. Dangerous number 8 This year 17 July 2014 Malaysia Airlines flight MH17 has crashed in Ukraine...",
        imgSrc:
            mumbai,
        buttonText: "Read More",
    },
    {
        title: "Romantic Bollywood couple and their numerology",
        date: "January 22, 2021",
        description:
            "Bollywood, the heart of Indian cinema, has given rise to legendary on-screen couples whose chemistry transcends the boundaries of the silver screen...",
        imgSrc:
            bollywood,
        buttonText: "Read More",
    },
    {
        title: "Dangerous number 8",
        date: "January 23, 2021",
        description:
            "If you observe my posts about number 8 … You will come to know that I consider this number as a dangerous number … I used to warn all 8 number peoples to be cautious and carefull on these dates 8,17 and 26 ….",
        imgSrc:
            eight,
        buttonText: "Read More",
    },
    {
        title: "Numerology of Number 1",
        date: "September 24, 2017",
        description:
            "Numerology is an ancient practice that explores the mystical connections between numbers and human destinies.",
        imgSrc:
            powerofBirth,
        buttonText: "Read More"
    },
    {
        title: "Numbers 2 and 3 Numerology",
        date: "September 24, 2017",
        description:
            "The number 23 is made up of the energies and vibrations of the number 2 and number 3. Number 2 resonates with imagination,creativity,diplomacy and cooperation.",
        imgSrc:
            numerlogy3,
        buttonText: "Read More"
    },
    {
        title: "⁠⁠⁠Magic of Number 10",
        date: "September 24, 2017",
        description:
            "My many clients are doing well with this powerful number … Many of them started worshipping this number because of the results they got in their life ….Yess if suited this number can get best out of you …",
        imgSrc:
            magic10,
        buttonText: "Read More"
    },
    {
        title: "Number 2 Numerology",
        date: "September 24, 2017",
        description:
            "⁠⁠⁠If you are born under these dates 2,11,20,29 of any month you are number 2",
        imgSrc:
            numerlogy2,
        buttonText: "Read More"
    },
    {
        title: "Sachin Tendulkar wears “10” because he is “Ten”dulkar",
        date: "September 24, 2017",
        description:
            "Sachin Tendulkar wears “10” because he is “Ten”dulkar, not to mention he is the best player in the team; just like in football, where you had Pele and Maradona wear 10.",
        imgSrc:
            sachin,
        buttonText: "Read More"
    },
    {
        title: "⁠⁠Transformation of Umesh Yadav after changing his jersey number and name spelling",
        date: "September 24, 2017",
        description:
            "Umesh Yadav is a great example who made an outstanding comeback in world cup 2015 with highest wicket...",
        imgSrc:
        UMESHYADHAV,
        buttonText: "Read More"
    },
];

export const servicesData = [
    {
        id: 1,
        image: service1 ,
        title: "Vehicle Number Selection",
        subTitle: "",
        price: "INR 1900/-",
        usd: "USD 10",
        rating: "4.5",
        duration: "25-30 Days",
        buttonText: "Add To Cart",
    },
    {
        id: 2,
        image: service2,
        title: "Lucky Number pendant suggestion or Gem stone suggestion",
        subTitle: "",
        price: "INR 1900/-",
        usd: "USD 10",
        rating: "4.5",
        duration: "25-30 Days",
        buttonText: "Add To Cart",
    },
    {
        id: 3,
        image: service3,
        title: "Mobile Number Selection",
        subTitle: "",
        price: "INR 1900/-",
        usd: "USD 10",
        rating: "4.5",
        duration: "25-30 Days",
        buttonText: "Add To Cart",
    },
    {
        id: 4,
        image: service4,
        title: "love or marriage compatibility consultation",
        subTitle: "",
        price: "INR 2800/-",
        usd: "USD 50",
        rating: "4.5",
        duration: "25-30 Days",
        buttonText: "Add To Cart",
    },
    {
        id: 5,
        image: service5,
        title: "Name spelling change or Baby name suggestion",
        subTitle: "",
        price: "INR 2800/-",
        usd: "USD 50",
        rating: "4.5",
        duration: "25-30 Days",
        buttonText: "Add To Cart",
    },
    {
        id: 6,
        image: service6,
        title: "Business name suggestion",
        subTitle: "",
        price: "INR 2800/-",
        usd: "USD 50",
        rating: "4.5",
        duration: "25-30 Days",
        buttonText: "Add To Cart",
    },
    {
        id: 7,
        image: service7,
        title: "Property number suggestion",
        subTitle: "",
        price: "INR 2800/-",
        usd: "USD 50",
        rating: "4.5",
        duration: "25-30 Days",
        buttonText: "Add To Cart",
    },
    {
        id: 8,
        image: service8,
        title: "Baby name / Business name / Name spelling / Career / Marriage Consultation ",
        subTitle: "",
        price: "INR 2800/-",
        usd: "USD 50",
        rating: "4.5",
        duration: "25-30 Days",
        buttonText: "Add To Cart",
    },
    {
        id: 9,
        image: service9,
        title: "Full Numerology Telephonic Consultation",
        subTitle: "",
        price: "INR 5500/-",
        usd: "USD 150",
        rating: "4.5",
        duration: "25-30 Days",
        buttonText: "Add To Cart",
    },
    {
        id: 10,
        image: service10,
        title: "Personal consultation",
        subTitle: "",
        price: "INR 8200/-",
        usd: "USD 200",
        rating: "4.5",
        duration: "25-30 Days",
        buttonText: "Add To Cart",
    },
    {
        id: 11,
        image: service11,
        title: "Urgent consultation",
        subTitle: "",
        price: "INR 10,000/-",
        usd: "USD 200",
        rating: "4.5",
        duration: "25-30 Days",
        buttonText: "Add To Cart",
    },
    {
        id: 12,
        image: service12,
        title: "Google Meet or Zoom meeting consultation",
        subTitle: "",
        price: "INR 10,000/-",
        usd: "USD 200",
        rating: "4.5",
        duration: "25-30 Days",
        buttonText: "Add To Cart",
    },
/*     {
        id: 13,
        image: service13,
        title: "Full Numerology telephonic consultation",
        subTitle: "",
        price: "INR 5500/-",
        usd: "USD 150",
        rating: "4.5",
        duration: "25-30 Days",
        buttonText: "Add To Cart",
    }, */
    {
        id: 14,
        image: service14,
        title: "Movie related tips",
        subTitle: "",
        price: "INR 25,000/-",
        usd: "USD 300",
        rating: "4.5",
        duration: "25-30 Days",
        buttonText: "Add To Cart",
    },
    {
        id: 15,
        image: service15,
        title: "Building / Real estate Projects suggestions",
        subTitle: "",
        price: "INR 25,000/-",
        usd: "USD 300",
        rating: "4.5",
        duration: "25-30 Days",
        buttonText: "Add To Cart",
    },
];


